/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'townsquare-comments.comment-action-bar.delete-button': 'Slet',
  'townsquare-comments.comment-action-bar.edit-button': 'Rediger',
  'townsquare-comments.comment-action-bar.reply-button': 'Svar',
  'townsquare-comments.comment.edited-date': 'redigeret kl. {time}',
  'townsquare-comments.comments.comments-title':
    '{itemCount, plural, =0 {Kommentarer} one {{itemCount,number} kommentar} other {{itemCount,number} kommentarer}}',
};
